import '../../../js/base';

import '../../../js/partials/salary-silo/_salary-by-year';

import '@zr/common/js/footer/_footer_light';
import initEmailAlertForm from '../../../js/partials/_email-alert-form';

initEmailAlertForm();

$('#salary_calculator_btn').on('click', () => {
  $.log_event('button_click', { field: 'salary_page_calculator_click' });
});
